// extracted by mini-css-extract-plugin
export default {"service-item-report-container":"serviceItems_service-item-report-container__5JVvI"};